export const TaskCompletionStatus = {
  Pending: 0,
  Snoozed: 1,
  Completed: 2,
};

export const TASK_DRAWER_WIDTH = 60;

export const Weekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
